export const baseUrl: string = '/manager/frontend-api/v1/'
